import React, { useState } from 'react';
import { RendererProps, getResultData } from './_shared';

export const JsonPreviewRenderer: React.FC<RendererProps> = ({ toolCall, darkMode }) => {
  const [expanded, setExpanded] = useState(false);
  const data = getResultData(toolCall);
  const json = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
  const preview = json.slice(0, 500);
  const needsExpand = json.length > 500;
  return (
    <pre
      className={`text-xs font-mono p-2 rounded whitespace-pre-wrap ${
        darkMode ? 'bg-gray-900 text-gray-300' : 'bg-gray-50 text-gray-700'
      }`}
    >
      {expanded || !needsExpand ? json : preview + '…'}
      {needsExpand && (
        <button
          onClick={() => setExpanded((e) => !e)}
          className="ml-2 text-violet-500 text-xs underline"
        >
          {expanded ? 'collapse' : 'expand'}
        </button>
      )}
    </pre>
  );
};
